// extracted by mini-css-extract-plugin
export var loadingSpinner = "_19-0";
export var spinnerContainer = "_19-1";